/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgDecline.css";
import { simpleFetch } from "../../restWrapper";
import PropTypes from "prop-types";
import { renderOrgLanguageSelector } from "../../assets/component/renderOrgLanguageSelector.js";

class OrgDecline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: this.props.language,
      msg: "",
    };
  }
  componentDidMount() {
    simpleFetch("/organizations", "GET", {}).then((res) => {
      if (res.body === null) {
        this.props.orgLogout();
      }
      if (res.body.organization) {
        const organizationType = res.body.organizationObj.organizationType;
        const isBusiness = organizationType === "business";

        // Business organizations should never be declined, redirect them to AccountOverview
        if (
          isBusiness ||
          res.body.organizationObj.organizationPermitted !== "declined"
        ) {
          this.props.history.push({
            pathname: "/AccountOverview",
          });
          return false;
        }
        this.setState({
          msg: res.body.organizationObj.organizationPermittedReason,
        });
      }
    });
  }
  render() {
    const languageObj = this.props.languageObj;
    return (
      <div className="OrgDecline-view">
        <div className="OrgDecline-header">
          <div className="OrgDecline-CheckPlusLogoContainer">
            <div className="OrgDecline-CheckPlusLogo" />
          </div>

          <div className="OrgDecline-languageBar">
            <div className="OrgDecline-languageSelector">
              {renderOrgLanguageSelector()}
            </div>
          </div>
        </div>

        <div className="OrgDecline-prompt">
          <div className="OrgDecline-declineContainer">
            <div className="OrgDecline-declineIcn"></div>
            <div className="OrgDecline-text">
              {" "}
              {languageObj.text[0]}
              <br />
              {languageObj.text[1]}
            </div>
            <div className="OrgDecline-reason">
              {languageObj.reason}
              {this.state.msg}
              <p />

              <br />
            </div>
            <div
              className="OrgDecline-doneBtn"
              onClick={(e) => {
                this.props.orgLogout();
              }}
            >
              {languageObj.doneBtn}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
OrgDecline.propTypes = {
  orgLogout: PropTypes.func,
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default OrgDecline;
